module.exports = __webpack_public_path__ + "static/media/sourcesanspro-bold-webfont.db089244.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/sourcesanspro-bold-webfont.woff2
// module id = 279
// module chunks = 0